import {
  BIconTelegram,
  BIconWhatsapp,
  BIconChatText,
  BIconEnvelope,
} from 'bootstrap-vue'

export default {
  name: 'OtpSenderWaysModal',
  components: {
    BIconTelegram,
    BIconWhatsapp,
    BIconChatText,
    BIconEnvelope,
  },
  props: {
    senderModal: {
      type: Boolean,
      required: true,
    },

  },
  data() {
    return {
      selectedType: null,
    }
  },
  methods: {
    onSendType(method) {
      this.selectedType = method
      this.$emit('send-verification-code', method)
    },
    onSubmit() {
      if (this.selectedType) {
        this.$emit('submit', this.selectedType)
      }
    },
    onClose() {
      this.$emit('close')
    },
  },
}
